export default "__VITE_ASSET__ed77d887__"